import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import classNames from 'classnames'
import moment from 'moment'
import Guid from 'guid'
import immutable from 'immutable'

import {TravelSearchResults} from './travelsearchresults.component'
import {TravelItem} from './travelitem.component'

import {AutoComplete} from '../widgets/autocomplete/autocomplete.component'
import {LunaLoader} from '../widgets/lunaloader/lunaloader.component'
import {HeaderBlock} from '../widgets/layout/headerblock.component'
import {SearchFail} from '../widgets/searchfail.component'

const SEARCH_URL = '/api/v1/destinations/search/'
const OPENCAGE_URL = '/api/v1/destinations/geocoder/search/'
const OPENCAGE_POST_URL = '/api/v1/destinations/geocoder/save/'
const SABRE_URL = '/api/v1/sabre/search/'
const SABRE_POST_URL = '/api/v1/sabre/save/'

export class TravelSearch extends React.Component {
    constructor(props) {
        super(props)

        this._isMounted = false
        this._maxDuration = 0

        this.state = {
            leg: this.props.leg,
            prevLeg: this.props.prevLeg,
            nextLeg: this.props.nextLeg,
            params: null,
            results: null,
            loading: true,
            loadingMssg: 'Searching...',
            origination: this.props.origination,
            return: this.props.return,
            depCity: null,
            arrCity: null,
            showSearchItem: false,
            selectedSearchItem: null
        }

        _.bindAll(this,
            'getRoutes',
            'getContent',
            'onChooseDep',
            'onChooseArr',
            'onExecuteQuery',
            'onRenderResult',
            'onOpenCageQuery',
            'addTransportation',
            'didLegsChange',
            'getTravelEndpoints',
            'activateSearchItem',
            'deActivateSearchItem',
            'getDuration',
            'processResults'
        )
    }

    componentWillReceiveProps(nextProps) {
    // If we update the leg after mounting, we need to refresh our destinations
        let didChange = this.didLegsChange(nextProps.nextLeg, nextProps.prevLeg, nextProps.leg)
        // one of the legs has changed, update the state
        if (didChange) {
            this.setState({leg: nextProps.leg, prevLeg: nextProps.prevLeg, nextLeg: nextProps.nextLeg, params: null, arrCity: null, depCity: null, results: null, loading: true, loadingMssg: ''})
            // this.getRoutes()
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        let didChange = this.didLegsChange(nextProps.nextLeg, nextProps.prevLeg, nextProps.leg) // check if prev, next, or current leg actually changed
        if (this.state.loadingMssg !== nextState.loadingMssg || nextState.showSearchItem !== this.state.showSearchItem || nextState.arrCity !== this.state.arrCity || nextState.depCity !== this.state.depCity || this.state.loading !== nextState.loading || didChange) {
            return true
        } else {
            return false
        }
    }

    componentDidUpdate(prevProps, prevState) {
    // make sure we're not repeating the same search here
        if (prevState.arrCity !== this.state.arrCity || prevState.depCity !== this.state.depCity || prevState.prevLeg !== this.state.prevLeg || prevState.nextLeg !== this.state.nextLeg || prevState.leg.getIn(['id']) !== this.state.leg.getIn(['id'])) {
            this.getRoutes()
        }
    }

    componentDidMount() {
        this._isMounted = true
        this.getRoutes()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    getDuration(duration) {
        if (duration > 0) {
            // TODO: I think duration is in minutes. need to confirm
            let d = duration * 60000 // convert to milliseconds
            let t = moment.duration(d)
            return <span>{t.hours()}h {t.minutes()}m</span>
        } else {
            return null
        }
    }

    activateSearchItem(item) {
        this.setState({showSearchItem: true, selectedSearchItem: item})
    }

    deActivateSearchItem() {
        this.setState({showSearchItem: false, selectedSearchItem: null})
    }

    didLegsChange(nextLeg, prevLeg, thisLeg) {
    // check if any legs changed
    // get the incoming id's for comparison, the object may be undefined
        let nextPropsNextLegID = nextLeg ? nextLeg.get('id') : null
        let nextPropsPrevLegID = prevLeg ? prevLeg.get('id') : null
        // get the current id's for comparision, the object may be undefined
        let curStateNextLegID = this.state.nextLeg ? this.state.nextLeg.get('id') : null
        let curStatePrevLegID = this.state.prevLeg ? this.state.prevLeg.get('id') : null

        if (nextPropsPrevLegID !== curStatePrevLegID || nextPropsNextLegID !== curStateNextLegID || thisLeg.get('id') !== this.state.leg.get('id')) {
            return true
        } else {
            return false
        }
    }

    processResults(items) {
        let pResults = []
        let pRoutes = []
        let places = items.places
        let airlines = items.airlines
        let agencies = items.agencies
        let vehicles = items.vehicles

        // process each route
        pRoutes = items.routes.map((route, r) => {
            let pRoute = route
            pRoute.transportation_guid = Guid.raw()
            if (pRoute.totalDuration > this._maxDuration) {
                this._maxDuration = pRoute.totalDuration
            }
            // process each segment of the route
            let pSegments = route.segments.map((segment, s) => {
                let pSegment = segment
                pSegment.arrPlace = places[segment.arrPlace]
                pSegment.depPlace = places[segment.depPlace]
                pSegment.vehicle = vehicles[segment.vehicle]
                if (segment.agencies) {
                    let tAgencies = segment.agencies.map((agency, a) => {
                        return _.find(segment.agencies, function(item) { return item.agency === agency.agency })
                    })
                    pSegment.agencies = tAgencies
                }

                if (segment.outbound) {
                    let pOutbounds = segment.outbound.map((outbound, index) => {
                        let pOutbound = outbound
                        let pHops = outbound.hops.map((hop, index) => {
                            hop.arrPlace = places[hop.arrPlace]
                            hop.depPlace = places[hop.depPlace]
                            hop.airline = airlines[hop.airline]
                            return hop
                        })
                        pOutbound.hops = pHops
                        return pOutbound
                    })
                    pSegment.outbound = pOutbounds
                }

                if (segment.return) {
                    let pReturns = segment.return.map((rTurn, index) => {
                        let pReturn = rTurn
                        let pHops = rTurn.hops.map((hop, index) => {
                            hop.arrPlace = places[hop.arrPlace]
                            hop.depPlace = places[hop.depPlace]
                            hop.airline = airlines[hop.airline]
                            return hop
                        })
                        pReturn.hops = pHops
                        return pReturn
                    })
                    pSegment.return = pReturns
                }

                return pSegment
            })
            pRoute.segments = pSegments
            return pRoute
        })
        return pRoutes
    }

    addTransportation(transportation) {
    // depending on subsection we need to pass arrival and departure leg ids
        let depLeg = -1
        let arrLeg = -1

        switch (this.props.detailSubDetail) {
            case 'ARRIVAL':
                // dep is origin, arr is current (origin has slightly different structure)
                depLeg = this.state.prevLeg ? this.state.prevLeg.get('id') : this.state.origination ? this.state.origination.get('id') : -1
                arrLeg = this.state.leg.get('id')
                break
            case 'DEPARTURE':
                // dep is current, arr is return
                depLeg = this.state.leg.get('id')
                arrLeg = this.state.nextLeg ? this.state.nextLeg.get('id') : this.state .return ? this.state.return.get('id') : -1
                break
            case 'LOCAL':
                // dep and arr are both current
                depLeg = this.state.leg.getIn(['id'])
                arrLeg = depLeg
                break
            default:
                // seomthing went wrong...
                alert('Error in onAddTransportation in travelsearch.component')
                return false
                break
        }

        let depCity = this.state.depCity ? this.state.depCity : null
        let arrCity = this.state.arrCity ? this.state.arrCity : null

        if (depLeg && arrLeg) {
            this.props.onAddTransportation(depLeg, arrLeg, depCity, arrCity, transportation, this.props.user)
        }
    }

    onChooseDep(choice) {
        if (!this.state.prevLeg) {
            this.props.onUpdateOrigin(choice)
        }

        let tDep = new immutable.fromJS(choice)
        this.setState({depCity: tDep, loading: true, results: null})
    }

    onChooseArr(choice) {
        if (this.state.nextLeg) {
            this.props.onUpdateReturn(choice)
        }

        let tArr = new immutable.fromJS(choice)
        this.setState({arrCity: tArr, loading: true, results: null})
    }

    onExecuteQuery(q) {
        return axios.get(SEARCH_URL, {
            params: {
                query: q
            }
        }).then((response) => response.data.results)
    }

    onOpenCageQuery(q) {
    // console.log('opencage search')
        return axios.get(OPENCAGE_URL, {
            params: {
                address: q
            }
        }).then((response) => response.data.data)
    }

    onRenderResult(result) {
        return (
            <span>{result.name}</span>
        )
    }

    getRoutes() {
        // need to set self for scope of ajax query
        let self = this
        let params = []
        let mssg = 'Searching...'

        let depName       = null
        let depLat        = null
        let depLon        = null
        let arrName       = null
        let arrLat        = null
        let arrLon        = null

        switch (this.props.detailSubDetail) {
            case 'ARRIVAL':
                if (this.state.prevLeg || this.state.depCity || this.state.origination) {
                    depName = this.state.depCity ? this.state.depCity.get('name') : this.state.prevLeg ? this.state.prevLeg.getIn(['destination', 'title']) : this.state.origination ? this.state.origination.getIn(['destination', 'title']) : ''
                    arrName = this.state.arrCity ? this.state.arrCity.getIn('name') : this.state.leg.getIn(['destination', 'title'])

                    if (this.state.depCity) {
                        depLat = this.state.depCity.getIn(['opencage', 'location', 'lat']) ? this.state.depCity.getIn(['opencage', 'location', 'lat']) : this.state.depCity.get('latitude')
                        depLon = this.state.depCity.getIn(['opencage', 'location', 'lon']) ? this.state.depCity.getIn(['opencage', 'location', 'lon']) : this.state.depCity.get('longitude')
                    } else if (this.state.prevLeg) {
                        depLat = this.state.prevLeg.getIn(['destination', 'location', 'latitude'])
                        depLon = this.state.prevLeg.getIn(['destination', 'location', 'longitude'])
                    } else {
                        depLat = this.state.origination.getIn(['destination', 'location', 'latitude'])
                        depLon = this.state.origination.getIn(['destination', 'location', 'longitude'])
                    }

                    if (this.state.arrCity) {
                        arrLat = this.state.arrCity.getIn(['opencage', 'location', 'lat']) ? this.state.arrCity.getIn(['opencage', 'location', 'lat']) : this.state.arrCity.get('latitude')
                        arrLon = this.state.arrCity.getIn(['opencage', 'location', 'lon']) ? this.state.arrCity.getIn(['opencage', 'location', 'lon']) : this.state.arrCity.get('longitude')
                    } else {
                        arrLat = this.state.leg.getIn(['destination', 'location', 'latitude'])
                        arrLon = this.state.leg.getIn(['destination', 'location', 'longitude'])
                    }
                } else {
                    console.log('prevLeg not set.')
                    return false
                }
                break
            case 'DEPARTURE':
                if (this.props.nextLeg || this.state.arrCity || this.state.return) {
                    depName = this.state.depCity ? this.state.depCity.get('name') : this.state.leg.getIn(['destination', 'title'])
                    arrName = this.state.arrCity ? this.state.arrCity.get('name') : this.state.nextLeg ? this.state.nextLeg.getIn(['destination', 'title']) : this.state.return ? this.state.return.getIn(['destination', 'title']) : ''
                    if (this.state.depCity) {
                        depLat = this.state.depCity.getIn(['opencage', 'location', 'lat']) ? this.state.depCity.getIn(['opencage', 'location', 'lat']) : this.state.depCity.get('latitude')
                        depLon = this.state.depCity.getIn(['opencage', 'location', 'lon']) ? this.state.depCity.getIn(['opencage', 'location', 'lon']) : this.state.depCity.get('longitude')
                    } else {
                        depLat = this.state.leg.getIn(['destination', 'location', 'latitude'])
                        depLon = this.state.leg.getIn(['destination', 'location', 'longitude'])
                    }

                    if (this.state.arrCity) {
                        arrLat = this.state.arrCity.getIn(['opencage', 'location', 'lat']) ? this.state.arrCity.getIn(['opencage', 'location', 'lat']) : this.state.arrCity.get('latitude')
                        arrLon = this.state.arrCity.getIn(['opencage', 'location', 'lon']) ? this.state.arrCity.getIn(['opencage', 'location', 'lon']) : this.state.arrCity.get('longitude')
                    } else if (this.state.nextLeg) {
                        arrLat = this.state.nextLeg.getIn(['destination', 'location', 'latitude'])
                        arrLon = this.state.nextLeg.getIn(['destination', 'location', 'longitude'])
                    } else {
                        depLat = this.state.return.getIn(['destination', 'location', 'latitude'])
                        depLon = this.state.return.getIn(['destination', 'location', 'longitude'])
                    }
                } else {
                    console.log('nextLeg not set.')
                    return false
                }
                break
            case 'LOCAL':
                console.log('TBD: Local Travel Search')
                return false
                break
        }


        if (arrLat && arrLon && depLat && depLon) {
            mssg = 'Searching for ' + depName + ' To ' + arrName
            params = {
                'origin-coordinates': depLat + ',' + depLon,
                'destination-coordinates': arrLat + ',' + arrLon,
            }
        } else {
            console.log('Error getting locations, aborting search')
            return false
        }

        if (this.state.params) {
            if (this.state.params['origin-coordinates'] === params['origin-coordinates'] && this.state.params['destination-coordinates'] === params['destination-coordinates']) {
                console.log('params match... cancel search')
                return false
            } else {
                if (this._isMounted) {
                    console.log('params dont match, set params')
                    this.setState({params: params})
                }
            }
        } else {
            if (this._isMounted) {
                console.log('params was null, set params')
                this.setState({params: params})
            }
        }

        // All seems well we're gonna do a search...
        if (this._isMounted) {
            this.setState({loadingMssg: mssg})
            axios.get('/api/v1/transportation/find', {
                params: params
            }).then(function(response) {
                var data = []
                if (self._isMounted) {
                    if (typeof response.data != 'undefined') {
                        data = response.data
                        // console.log('We have results!')
                        // console.log(data)
                        self.setState({results: self.processResults(data), loading: false})
                    } else {
                        console.log('TODO: handle error')
                        self.setState({results: null, loading: false})
                    }
                }
            })
        }
    }

    getTravelEndpoints() {
        switch (this.props.detailSubDetail) {
            case 'ARRIVAL':
                let originName = this.state.depCity ? this.state.depCity.get('name') : this.state.prevLeg ? this.state.prevLeg.getIn(['destination', 'title']) : this.state.origination ? this.state.origination.getIn(['destination', 'title']) : 'Origin Not Set'
                return (
                    <div className="origin-form">
                        <div className="origin-origin-block origin-block">
                            <span>Origin City</span>
                            <AutoComplete
                  onExecuteQuery={this.onExecuteQuery}
                  onRenderResult={this.onRenderResult}
                  onChoose={this.onChooseDep}
                  placeholder={originName}/>
                        </div>
                        <i className="icon-arrow_right_b"/>
                        <div className="origin-dest-block origin-block">
                            <span>Arrival City</span>
                            <div className="origin-dest">{ this.props.leg.getIn(['destination', 'title']) }</div>
                        </div>
                    </div>
                )
                break
            case 'DEPARTURE':
                let returnName = this.state.arrCity ? this.state.arrCity.get('name') : this.state.nextLeg ? this.state.nextLeg.getIn(['destination', 'title']) : this.state.return ? this.state.return.getIn(['destination', 'title']) : 'Return Not Set'

                return (
                    <div className="origin-form">
                        <div className="origin-dest-block origin-block">
                            <span>Origin City</span>
                            <div className="origin-dest">{ this.props.leg.getIn(['destination', 'title']) }</div>
                        </div>
                        <i className="icon-arrow_right_b"/>
                        <div className="origin-origin-block origin-block">
                            <span>Return City</span>
                            <AutoComplete
                  onExecuteQuery={this.onExecuteQuery}
                  onRenderResult={this.onRenderResult}
                  onChoose={this.onChooseArr}
                  placeholder={returnName}/>
                        </div>
                    </div>
                )
                break
            case 'LOCAL':
                return <div><SearchFail {...this.props} type="travel"/></div>
                break
        }
    }

    getContent() {
        switch (this.props.detailSubDetail) {
            case 'ARRIVAL':
                if (!this.state.prevLeg && !this.state.depCity && !this.state.origination) {
                    // no previous leg, assume it's the first leg so get origin city
                    // show autocomplete, onChoose set origin, if button is active that return is the same, set return, else move on
                    return (
                        <h1 className="align-center">Please set an Originiation City using the form above.</h1>
                    )
                } else {
                    if (this.state.loading) {
                        return <div className="loader-mssg"><LunaLoader style="basic"/>{this.state.loadingMssg}</div>
                    } else {
                        if (this.state.results) {
                            return <TravelSearchResults {...this.props} maxDuration={this._maxDuration} activateSearchItem={this.activateSearchItem} deActivateSearchItem={this.deActivateSearchItem} getDuration={this.getDuration} results={this.state.results} addTransportation={this.addTransportation}/>
                        } else {
                            return <SearchFail {...this.props} type="travel"/>
                        }
                    }
                }
                break
            case 'DEPARTURE':
                if (!this.state.nextLeg && !this.state.arrCity && !this.state.return) {
                    // no nextLeg
                    return (
                        <h1 className="align-center">Please set an Return City using the form above.</h1>
                    )
                } else {
                    if (this.state.loading) {
                        return <div className="loader-mssg"><LunaLoader style="basic"/>{this.state.loadingMssg}</div>
                    } else {
                        if (this.state.results) {
                            return <TravelSearchResults {...this.props} maxDuration={this._maxDuration} activateSearchItem={this.activateSearchItem} deActivateSearchItem={this.deActivateSearchItem} getDuration={this.getDuration} results={this.state.results} addTransportation={this.addTransportation}/>
                        } else {
                            return <SearchFail {...this.props} type="travel"/>
                        }
                    }
                }
                break
            case 'LOCAL':
                return null
                break
        }
    }

    render() {
        let header = () => {
            switch (this.props.detailSubDetail) {
                case 'ARRIVAL':
                    return 'Getting There'
                    break
                case 'LOCAL':
                    return 'Getting Around'
                    break
                case 'DEPARTURE':
                    return 'Leaving'
                    break
            }
        }

        if (this.state.showSearchItem) {
            return <TravelItem {...this.props} inItin={false} getDuration={this.getDuration} goBack={ this.deActivateSearchItem } item={ this.state.selectedSearchItem }  addTransportation={this.addTransportation} onRemoveTransportation = {this.props.onRemoveTransportation}/>
        } else {
            return (
                <div className="view-area">
                    <div className="view-left-col">
                        <a onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.TRAVEL, this.props.availableDetailSubSections.OVERVIEW)} className="btn">BACK</a>
                    </div>
                    <div className="view-center">
                        <HeaderBlock header={header} body=""/>
                        { this.getTravelEndpoints() }
                        { this.getContent() }
                    </div>
                    <div className="view-right-col">
                        <a className="btn btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.TRAVEL, this.props.availableDetailSubSections.ENTRY, this.props.detailSubDetail)}>
                            <i className="icon-circle_add"/><span>ADD MY OWN</span>
                        </a>
                    </div>
                </div>
            )
        }
    }
}
